import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Plus, Search, Pencil, Trash2, Check, X, MessageSquare } from "lucide-react";
import { AI2 } from "./api";

const Row = ({ c, active, onOpen, onChanged }) => {
  const [edit, setEdit] = useState(false);
  const [title, setTitle] = useState(c.title);
  const save = async () => {
    await axios.patch(`${AI2}/conversations/${c.id}`, { title }).then(() => { setEdit(false); onChanged(); }).catch(() => toast.error("Couldn't rename"));
  };
  const del = async (e) => {
    e.stopPropagation();
    if (!window.confirm("Delete this conversation?")) return;
    await axios.delete(`${AI2}/conversations/${c.id}`).then(() => onChanged(c.id)).catch(() => toast.error("Couldn't delete"));
  };
  if (edit) {
    return (
      <div className="ai2-conv active" data-testid={`ai2-conv-edit-${c.id}`}>
        <input className="input" style={{ flex: 1, height: 28 }} value={title} autoFocus onChange={(e) => setTitle(e.target.value)} onKeyDown={(e) => e.key === "Enter" && save()} data-testid="ai2-conv-rename-input" />
        <button className="btn btn-ghost btn-sm" onClick={save} aria-label="Save" data-testid="ai2-conv-rename-save"><Check size={14} /></button>
        <button className="btn btn-ghost btn-sm" onClick={() => setEdit(false)} aria-label="Cancel"><X size={14} /></button>
      </div>
    );
  }
  return (
    <div className={`ai2-conv ${active ? "active" : ""}`} onClick={() => onOpen(c.id)} data-testid={`ai2-conv-${c.id}`}>
      <MessageSquare size={13} style={{ flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.title}</div>
        <div className="muted" style={{ fontSize: 10, fontWeight: 400 }}>{c.location_name} · {new Date(c.updated_at).toLocaleDateString()}</div>
      </div>
      <div className="ai2-conv-actions">
        <button className="btn btn-ghost btn-sm" style={{ padding: 4 }} onClick={(e) => { e.stopPropagation(); setEdit(true); }} aria-label="Rename" data-testid={`ai2-conv-rename-${c.id}`}><Pencil size={12} /></button>
        <button className="btn btn-ghost btn-sm" style={{ padding: 4 }} onClick={del} aria-label="Delete" data-testid={`ai2-conv-delete-${c.id}`}><Trash2 size={12} /></button>
      </div>
    </div>
  );
};

export const ConversationList = ({ convs, activeId, q, setQ, onOpen, onNew, onChanged, onClose }) => (
  <div className="card ai2-col" style={{ padding: 12, height: "100%" }} data-testid="ai2-conv-list">
    <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
      <button className="btn btn-primary" style={{ flex: 1, justifyContent: "center" }} onClick={onNew} data-testid="ai2-new-chat"><Plus size={14} />New conversation</button>
      {onClose && <button className="btn ai2-mobile-only" onClick={onClose} aria-label="Close list" data-testid="ai2-conv-list-close"><X size={14} /></button>}
    </div>
    <div style={{ position: "relative", marginBottom: 10 }}>
      <Search size={13} style={{ position: "absolute", left: 9, top: 10, color: "var(--muted)" }} />
      <input className="input" style={{ width: "100%", paddingLeft: 28 }} placeholder="Search conversations" value={q} onChange={(e) => setQ(e.target.value)} data-testid="ai2-conv-search" />
    </div>
    <div className="ai2-scroll" style={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {!convs.length && <div className="muted" style={{ fontSize: 12, padding: 8 }} data-testid="ai2-conv-empty">{q ? "No conversations match." : "Your conversations will appear here."}</div>}
      {convs.map((c) => <Row key={c.id} c={c} active={c.id === activeId} onOpen={onOpen} onChanged={onChanged} />)}
    </div>
  </div>
);
